import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const RecommendationsCard: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Рекомендации по дальнейшему развитию</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <h4 className="font-semibold text-red-800 mb-2">🔴 Критичные задачи</h4>
            <ul className="text-sm text-red-700 space-y-1">
              <li>• Исправить TypeScript ошибки в categoryService.ts</li>
              <li>• Завершить интеграцию с фискальным оборудованием (54-ФЗ)</li>
              <li>• Настроить SMTP для email уведомлений</li>
            </ul>
          </div>
          
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <h4 className="font-semibold text-yellow-800 mb-2">🟡 Важные улучшения</h4>
            <ul className="text-sm text-yellow-700 space-y-1">
              <li>• Расширить функционал аналитики и отчетов</li>
              <li>• Добавить PWA поддержку для мобильных устройств</li>
              <li>• Интегрировать с внешними сервисами доставки</li>
              <li>• Добавить систему резервного копирования</li>
            </ul>
          </div>
          
          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h4 className="font-semibold text-blue-800 mb-2">🔵 Будущие возможности</h4>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• Мобильное приложение (React Native)</li>
              <li>• AI-ассистент для клиентов</li>
              <li>• Интеграция с CRM системами</li>
              <li>• Многоязычная поддержка</li>
              <li>• Продвинутая аналитика с ML</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RecommendationsCard;
